export default "__VITE_ASSET__6ea5c284__"